import { window } from "../window";

/**
 * Resets and controls the browser's navigation history to prevent unwanted back navigation.
 */

export const resetBrowserNavigationHistory = (): (() => void) => {
  const currentPath = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  const fullUrl = currentPath + (searchParams.toString() ? `?${searchParams.toString()}` : "");

  window.history.pushState("", "", fullUrl);
  window.history.pushState("", "", fullUrl);
  window.history.go(-1);

  const preventNavigation = () => {
    window.history.pushState(null, "", fullUrl);
  };

  window.addEventListener("popstate", preventNavigation);

  return () => {
    window.removeEventListener("popstate", preventNavigation);
  };
};
